import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'os-sw',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: 'os-sw',
    method: 'get',
    params: queriesParams
  })
}

export function fetchVerifySerial(serial) {
  return request({
    url: `verify-serial/${serial}`,
    method: 'get'
  })
}

export function addOs (data) {
  return request({
    method: 'post',
    url: 'os-sw',
    data: {
      oss: data
    }
  })
}

export function fetchCheckContractAndBoard (params) {
  return request({
    url: 'checkcontractandboard',
    method: 'get',
    params
  })
}

export function fetchAllPageOsSWForm () {
  return request({
    url: 'all-page-os-sw-form',
    method: 'get'
  })
}

export function fetchVehicleData(params) {
  return request({
    url: `os-sw/vehicledata?`,
    method: 'get',
    params
  })
}

export function fetchVehiclesToReuse(params) {
  return request({
    url: `os-sw/vehicles-to-reuse?`,
    method: 'get',
    params
  })
}